
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/facebook",
      function () {
        return require("private-next-pages/facebook.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/facebook"])
      });
    }
  